import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8% 0px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", delay = 0, stagger = 0.12, as = "h1", inView = false, ...rest }) => {
  const MTag = motion[as];
  const ctrl = inView ? { whileInView: "show", viewport: { once: true, margin: "-10% 0px" } } : { animate: "show" };
  return (
    <MTag className={className} initial="hidden" {...ctrl} {...rest}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className="block will-change-transform"
            variants={{ hidden: { y: "115%" }, show: { y: 0 } }}
            transition={{ duration: 1.15, delay: delay + i * stagger, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </MTag>
  );
};

export const Eyebrow = ({ n, label, light = false, className = "" }) => (
  <div className={`flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.3em] ${light ? "text-brand-cyan" : "text-brand-indigo"} ${className}`}>
    <span>{n}</span>
    <span className={`h-px w-10 ${light ? "bg-brand-cyan/50" : "bg-brand-indigo/30"}`} />
    <span className={light ? "text-white/60" : "text-brand-ink/60"}>{label}</span>
  </div>
);
